import { Box, Flex, Text } from "@chakra-ui/react"
import BotAvatar from "./BotAvatar"
import { CONVERSATION_TOO_LONG, NAVY } from "./constants"

// useChat's transport throws the proxy's response body as the error message.
function errorCode(error) {
    try {
        return JSON.parse(error?.message)?.code
    } catch {
        return undefined
    }
}

export default function ChatError({ error, onReset }) {
    const tooLong = errorCode(error) === CONVERSATION_TOO_LONG

    return (
        <Flex gap="10px" align="flex-end" w="100%">
            <BotAvatar />
            <Box bg="#FEF2F2" borderRadius="12px 12px 12px 4px" px="14px" py="10px" maxW="80%">
                <Text fontSize="14px" color="#991B1B" lineHeight={1.5} mt={0}>
                    {tooLong
                        ? "This conversation has gotten too long for me to keep going. Please start a new chat to ask another question."
                        : "Something went wrong. Please try again."}
                </Text>
                {tooLong && onReset && (
                    <Box
                        as="button"
                        type="button"
                        onClick={onReset}
                        mt="8px"
                        px="12px"
                        py="6px"
                        bg={NAVY}
                        color="#fff"
                        fontSize="13px"
                        fontWeight={600}
                        borderRadius="999px"
                        cursor="pointer"
                    >
                        Start a new chat
                    </Box>
                )}
            </Box>
        </Flex>
    )
}
